
import { AttributeValue } from "../../../library-js/dom-tools/AttributeValue";
import { ElementType } from "../../../library-js/dom-tools/ElementType";
import { OnChange } from "../../../library-js/dom-tools/EventListeners";
import { InspectorField } from "./InspectorField";

export class BooleanField extends InspectorField<boolean>
{
  static readonly type = new ElementType( "boolean--field" );

  protected _inputField:HTMLInputElement;

  createElement() 
  {
    let element = BooleanField.type.create();
    InspectorField.flag.set( element );
    
    let inputField = ElementType.input.create();
    this._inputField = inputField;
    AttributeValue.type_checkbox.set( inputField );

    element.appendChild( inputField );

    

    OnChange.add( inputField,
      ()=>
      {
        this.value = inputField.checked;
        this.onChange.dispatch( this.value );
      }
    );

    this._element = element;
  }

  syncValueToElement()
  {
    this._inputField.checked = this.value;
  }
  
  
}